module.exports = __webpack_public_path__ + "static/media/basketball.ed0f3e6f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hero-backgrounds/basketball.jpg
// module id = 686
// module chunks = 0